import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Label, Input, FormGroup, Button } from "reactstrap";
import "../form.css";
import "bootstrap/dist/css/bootstrap.css";
import WorkoutApi from "../Api";

const UserEditForm = () => {
  // const {id} = useParams()
  let navigate = useNavigate();

  let newUser = JSON.parse(localStorage.getItem("user"));

  const [fData, setFormData] = useState(newUser);

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setFormData((fData) => ({
      ...fData,
      [name]: value,
    }));
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    WorkoutApi.patchUser(newUser.username, { ...fData }).then((res) => {
      window.localStorage.setItem("user", JSON.stringify(res));
    });
    navigate("/");
  };

  return (
    <>
      <h2> Edit User Profile </h2>
      <Form className="formBody" onSubmit={handleSubmit}>
        <FormGroup>
          <Label className="labelTitle" htmlFor="first_name">
            First Name
          </Label>
          <Input
            id="first_name"
            name="first_name"
            placeholder="Place Your First Name Here"
            type="text"
            value={fData.first_name}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label className="labelTitle" htmlFor="last_name">
            Last Name
          </Label>
          <Input
            id="last_name"
            name="last_name"
            placeholder="Place Your Last Name Here"
            type="text"
            value={fData.last_name}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label className="labelTitle" htmlFor="weight">
            Weight
          </Label>
          <Input
            id="weight"
            name="weight"
            placeholder="Place Your Weight in lb. Here"
            type="number"
            value={fData.weight}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label className="labelTitle" htmlFor="height">
            Height
          </Label>
          <Input
            id="height"
            name="height"
            placeholder="Place Your Height Here"
            type="text"
            value={fData.height}
            onChange={handleChange}
          />
        </FormGroup>
        <Button color="primary">Submit</Button>
      </Form>
    </>
  );
};

export default UserEditForm;
